import { render, staticRenderFns } from "./xgLoadcg.vue?vue&type=template&id=76eaaf42&"
import script from "./xgLoadcg.vue?vue&type=script&lang=js&"
export * from "./xgLoadcg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports